module.exports = __webpack_public_path__ + "img/air-5.25394eae.jpeg";